// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapImage } from '../../../dsl/front';
import { LineHeaderTheme } from './LineHeader.contracts';
import { siteLogoClassNameRegistry } from './LineHeader.config';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let LineHeader = class LineHeader extends Vue {
    /**
     * The CSS class that sets the `font-weight` of the main content.
     */
    get fontWeightClass() {
        return this.isBold ? 'fw-bold' : 'fw-normal';
    }
    /**
     * The CSS class that controls the `--with-pointer` modifier class.
     */
    get pointerClass() {
        return this.showPointer && !this.siteImgClass ? '--with-pointer' : null;
    }
    /**
     * Full path to the site's logotype.
     */
    get siteImgClass() {
        if (typeof this.site === 'undefined') {
            return;
        }
        const className = siteLogoClassNameRegistry[this.site];
        if (typeof className !== 'string' || className.length === 0) {
            return;
        }
        return `--${this.theme}-${className}`;
    }
    /**
     * The CSS class that sets the color scheme (light/dark) of the component.
     */
    get themeClass() {
        return `--${this.theme}`;
    }
};
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], LineHeader.prototype, "isBold", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], LineHeader.prototype, "showPointer", void 0);
__decorate([
    Prop({ type: String, required: false })
], LineHeader.prototype, "site", void 0);
__decorate([
    Prop({ type: String, required: false, default: 'h2' })
], LineHeader.prototype, "tag", void 0);
__decorate([
    Prop({ type: String, required: false, default: LineHeaderTheme.Light })
], LineHeader.prototype, "theme", void 0);
LineHeader = __decorate([
    Component({
        name: 'LineHeader',
        components: { BootstrapImage },
        template: `
    <header class="line-header" :class="themeClass">
      <component :is="tag" class="line-header__content text-ui-separator text-uppercase m-0 mt-4 mb-3"
                 :class="[fontWeightClass, pointerClass]">
        <i v-if="siteImgClass" :class="siteImgClass" class="line-header__content__site-logo" />

        <span :class="siteImgClass ? 'subtitle' : null">
          <slot />
        </span>
      </component>

      <slot name="nav" />
    </header>
  `
    })
], LineHeader);
export { LineHeader };
